import { rarityColor } from 'lib/rarityColor'
import { getRarityInfo } from 'shared'
import { RARITY_ICONS } from 'utils/rarityIcons'
import { CustomTooltip } from './CustomTooltip/CustomTooltip'

export interface RarityBadgeProps {
  /** Cardmarket rarity name, e.g. OrderProduct.rarity */
  rarity: string
  idGame: number
  className?: string
}

export const RarityBadge = ({
  rarity,
  idGame,
  className,
}: RarityBadgeProps): JSX.Element | null => {
  const info = getRarityInfo(idGame, rarity)
  if (!info) return null

  // matched on the Cardmarket name, so rarities sharing an internal id keep
  // their own icon; anything without one falls back to the colored badge
  const icon = RARITY_ICONS[idGame as keyof typeof RARITY_ICONS]?.[rarity]

  return (
    <CustomTooltip title={info.name}>
      {icon ? (
        <img
          data-testid={`rarity-icon-${info.filterLabel}`}
          className={`rarity-badge-icon ${className ?? ''}`}
          src={icon}
          alt={info.name}
        />
      ) : (
        <div
          data-testid={`rarity-badge-${info.filterLabel}`}
          className={`rarity-badge-container ${className ?? ''}`}
          style={{ backgroundColor: rarityColor(info.position) }}
        >
          {info.filterLabel}
        </div>
      )}
    </CustomTooltip>
  )
}
